interface KpiCardProps {
  label: string;
  value: string;
}

const KpiCard = ({ label, value }: KpiCardProps) => {
  return (
    <div className="rounded-lg border p-4 space-y-1">
      <p className="text-sm text-muted-foreground">{label}</p>
      <p className="text-xl font-semibold">{value}</p>
    </div>
  );
}

export default KpiCard;
